








































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DetailComponent from '@/components/meters/detail/DetailComponent.vue';
import ListStructuresCSV from '@/components/meters/detail/ListStructuresCSV.vue';
import ImportCSV from '@/components/meters/detail/ImportCSV.vue';
import MeterIdentifications from '@/components/meters/detail/MeterIdentifications.vue';
import MeterReading from "@/data/models/meter-reading";
import Meter from "@/data/models/meter";
import AdminOperation from "@/components/meters/detail/AdminOperation.vue";
import DataloggerRemote from "@/components/meters/detail/DataloggerRemote.vue";

@Component({
  components: {DataloggerRemote, AdminOperation, MeterIdentifications, ImportCSV, ListStructuresCSV, DetailComponent},
})
export default class DetailMeter extends Vue {
  @Prop({required: true})
  meterId: string;

  @Prop({required: true})
  buildingId: string;

  /** Onglet actif, porté par l'URL (/detailMeter/:buildingId/:meterId/:tab) pour être conservé au rechargement */
  @Prop({default: null})
  tab: string;


  buildingName: string = '';
  meterName: string = '';
  buildingImportSettings: any = null;
  hasClimkit: boolean = false;
  hasTetraedre: boolean = false;

  meter: Meter = null
  lastValue: MeterReading = null;
  valueCount: number = 0;

  get tabs(): Array<{ key: string; label: string }> {
    const tabs = [
      {key: 'structure', label: this.$t('detailMeter.tabs.structure').toString()},
      {key: 'identifications', label: this.$t('detailMeter.tabs.identifications').toString()},
      {key: 'administration', label: this.$t('detailMeter.tabs.clean').toString()},
    ];
    if (this.meter?.dataloggerMac) {
      tabs.push({key: 'datalogger', label: this.$t('detailMeter.tabs.datalogger').toString()});
    }
    return tabs;
  }

  get activeTab(): string {
    return this.tab || 'structure';
  }

  set activeTab(tab: string) {
    this.selectTab(tab);
  }

  tabRoute(tab: string): { name: string; params: Record<string, string> } {
    return {name: 'detailMeter', params: {buildingId: this.buildingId, meterId: this.meterId, tab}};
  }

  selectTab(tab: string): void {
    if (tab !== this.tab) {
      this.$router.replace(this.tabRoute(tab)).catch(() => undefined);
    }
  }

  /** Onglet absent ou inconnu → « Structures CSV » ; « Datalogger » seulement si le compteur a une MAC */
  @Watch('meter')
  @Watch('tab', {immediate: true})
  checkTab(): void {
    const known = ['structure', 'identifications', 'administration', 'datalogger'];
    if (!this.tab || !known.includes(this.tab) || (this.tab === 'datalogger' && this.meter && !this.meter.dataloggerMac)) {
      this.selectTab('structure');
    }
  }

  mounted(): void {
    this.getMeterDetail(this.meterId)
    this.$dao.meters.getLastValue(this.meterId).then(value => this.lastValue = value)
    this.getCountValues()
  }

  get showImportWarning(): string {
    if(this.buildingImportSettings == null) {
      return null;
    }

    if(this.hasClimkit && !this.buildingImportSettings.climkit) {
      return "Climkit"
    } else if(this.hasTetraedre && !this.buildingImportSettings.tetraedre) {
      return "Tetraedre"
    }

    return null;
  }

  hasCorrespondingImportSettings(filenames: []): void {
    // Check if there is a climkit file
    this.hasClimkit = filenames.some((filename: string) => filename.startsWith('climkit_'));
    this.hasTetraedre = filenames.some((filename: string) => filename.startsWith('tetraedre_'));
  }

  getCountValues(): void {
    this.$dao.meters.getCountValues(this.meterId).then(value => this.valueCount = value.count)
  }

  async getMeterDetail(meterId: string): Promise<void> {
    this.meter = await this.$dao.meters.getById(meterId);

    if (this.meter) {
      const building = await this.$dao.buildings.getById(this.meter.buildingId);
      this.buildingName = building?.name ?? '';
      this.meterName = this.meter.name;
      this.buildingImportSettings = JSON.parse(building?.importSettings ?? "{}") || null;
    }
  }

  get breadcrumbMeter(): string {
    return `${this.buildingName} > ${this.meterName}`;
  }

  get breadCrumb(): string {
    return this.buildingName
  }
}
